import {Component, computed, inject, OnDestroy, OnInit, Signal} from '@angular/core';
import {ProjectsService} from "../../services/projects.service";
import {environment} from "../../../../environments/environment";
import {Project} from "../../models/project.model";
import {Subject, takeUntil} from "rxjs";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute, Router, NavigationEnd} from "@angular/router";
import {CoreService} from "../../services/core.service";
import {ThemesService} from "../../services/themes.service";
import {filter} from "rxjs/operators";

const defaultAppTitle = environment.defaultAppTitle;

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.sass'],
  standalone: false
})
export class LayoutComponent implements OnInit, OnDestroy {

  projectShortName: string | null = null;
  activeProjects: any;

  private ngUnsubscribe = new Subject();

  private projectService = inject(ProjectsService);

  public globalLoadingSignal: boolean | Signal<boolean> = this.projectService.globalLoadingSignal();

  public title: string | null | undefined = '';
  public subTitle = '';
  public sidebar = true;
  public isThankYouPage = false;
  public isLeadGenerationStep = false;
  public globalLoading = true;
  public projectLine1 = '';
  public projectLine2 = '';

  public themeName = '';

  constructor(
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private coreService: CoreService,
    private themeService: ThemesService,
    private toastrService: ToastrService,
  ) {
    this.coreService.sidebar.subscribe((x) => {
      this.sidebar=x;
    } );
    this.coreService.thankYouPage.subscribe((x) => {
      this.isThankYouPage = x;
    });
    this.coreService.globalLoading.subscribe((x: boolean) => {
      this.globalLoading = x;
    });
    this.coreService.isLeadGenerationStep.subscribe((x: boolean) => {
      this.isLeadGenerationStep = x;
    });
    this.coreService.enableGlobalLoading();

  }

  ngOnInit() {
    // this.getActiveProjects();
    this.getCurrentTitlesAndSubTitles();
    this.projectShortName = this.activatedRoute.snapshot.paramMap.get('projectShortname');
    // console.log('paramMap', this.projectShortName);
    this.projectShortName = this.activatedRoute.snapshot.params['projectShortname'];
    // console.log('params', this.projectShortName);

    if(this.activatedRoute.parent?.params) {

      this.activatedRoute.parent.params?.subscribe(
        (params) => {
          // console.log('params', params);
          this.projectShortName = params['projectShortname'];
        });
    }

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params?.['theme']) {
        this.themeName = params['theme'].toLowerCase();
      }
    });

    this.themeService.addBodyClass();

    if (this.projectShortName) {
      this.projectService.getProject(this.projectShortName).pipe(
        takeUntil(this.ngUnsubscribe)
      ).subscribe({
          next: (project) => {

            this.themeService.checkThemeSettings(this.projectShortName);
            this.themeService.getProjectDetails();
            this.projectService.setLoading(true);
            this.title  = project.name;

          },
          complete: () => {},
          error: err => { this.toastrService.error(err); }
        }
      );
    }

    // Listen to router events to handle navigation changes
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((event) => {
        this.handleNavigationChange(event as NavigationEnd);
      });
  }

  loaded() {
    return this.globalLoadingSignal;
  }

  getLogoPath() {
    if (this.projectService.logo) {
      return this.projectService.logo;
    } else {
      return environment.defaultAppLogo;
    }
  }

  getThemeName() {
    return;
  }

  getApplicationName() {
    return this.projectService.getApplicationName();
  }

  // getActiveProjects() {
  //   // this.activeProjects = this.projectService.getActiveProjects();
  // }

  getCurrentTitlesAndSubTitles() {
    this.title = this.coreService.getTitle();
    // console.log(this.title);
    this.subTitle = this.coreService.getSubTitle();
  }

  private handleNavigationChange(event: NavigationEnd) {
    // Reset layout state based on the new route
    const url = event.url;
    
    // Check if it's a thank you page
    const isThankYouPage = url.includes('thank-you');
    this.coreService.thankYouPage.next(isThankYouPage);
    
    // Check if it's a lead generation step
    const isLeadGenerationStep = url.includes('step1') || url.includes('lead-generation');
    this.coreService.isLeadGenerationStep.next(isLeadGenerationStep);
    
    // Enable sidebar for most pages except thank you pages
    if (!isThankYouPage) {
      this.coreService.enableSidebar();
    }
    
    // Update project short name from the route
    const projectMatch = url.match(/registration\/([^\/]+)/);
    if (projectMatch) {
      this.projectShortName = projectMatch[1];
    }
    
    // Reinitialize theme and project settings if project short name changed
    if (this.projectShortName) {
      this.themeService.checkThemeSettings(this.projectShortName);
      this.themeService.getProjectDetails();
      // Ensure project data (name/logo) is loaded when navigating directly to steps
      this.projectService.getProject(this.projectShortName)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (project) => {
            this.projectService.setProject(project);
            this.title = project.name;
          },
          error: () => {}
        });
    }
    
    // Ensure global loading is properly managed
    this.coreService.enableGlobalLoading();
    
    // Update titles and subtitles based on current route
    this.getCurrentTitlesAndSubTitles();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(false);
    this.ngUnsubscribe.complete();
  }
}
